import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Toujours true
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà donné son consentement
    const consent = localStorage.getItem('cookieConsent');

    if (!consent) {

      // Attendre 1 seconde avant d'afficher la bannière
      setTimeout(() => setShowBanner(true), 1000);
    } else {

    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    setShowBanner(false);
    // Activer les scripts analytics/marketing ici si besoin
  };

  const handleRejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(onlyNecessary));
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    const saved = {
      ...preferences,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(saved));
    setShowBanner(false);
    setShowSettings(false);
    // Activer/désactiver les scripts selon les préférences
  };

  const handleTogglePreference = (type) => {
    if (type === 'necessary') return; // Ne pas permettre de désactiver les cookies nécessaires
    setPreferences((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  if (!showBanner) return null;


  return (
    <>
      <div 
        className="cookie-overlay" 
        onClick={() => setShowBanner(false)}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9998
        }}
      ></div>
      <div 
        className="cookie-consent"
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          maxWidth: '600px',
          width: 'calc(100% - 40px)',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
          padding: '30px',
          zIndex: 9999,
          borderTop: '5px solid #2c5f2d'
        }}
      >
        <div className="cookie-header">
          <span className="cookie-icon">🍪</span>
          <h3>Nous respectons votre vie privée</h3>
        </div>

        {!showSettings ? (
          <>
            <p className="cookie-description">
              Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
              Les cookies essentiels sont nécessaires au fonctionnement du site, tandis que 
              d'autres nous aident à comprendre comment vous l'utilisez.
            </p>

            <div className="cookie-buttons">
              <button onClick={handleRejectAll} className="btn-reject">
                Refuser tout
              </button>
              <button onClick={() => setShowSettings(true)} className="btn-settings">
                Personnaliser
              </button>
              <button onClick={handleAcceptAll} className="btn-accept">
                Accepter tout
              </button>
            </div>

            <a 
              href="/politique-confidentialite" 
              className="cookie-link"
              rel="noopener noreferrer"
            >
              En savoir plus sur notre politique de confidentialité
            </a>
          </>
        ) : (
          <>
            <div className="cookie-preferences">
              <div className="preference-item">
                <div className="preference-header">
                  <div>
                    <h4>🔒 Cookies nécessaires</h4>
                    <p>Indispensables au fonctionnement du site</p>
                  </div>
                  <label className="switch disabled">
                    <input type="checkbox" checked disabled />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>

              <div className="preference-item">
                <div className="preference-header">
                  <div>
                    <h4>📊 Cookies analytiques</h4>
                    <p>Nous aident à comprendre comment vous utilisez le site</p>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={() => handleTogglePreference('analytics')}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>

              <div className="preference-item">
                <div className="preference-header">
                  <div>
                    <h4>🎯 Cookies marketing</h4>
                    <p>Utilisés pour personnaliser les publicités</p>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={() => handleTogglePreference('marketing')}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            </div>

            <div className="cookie-buttons">
              <button onClick={() => setShowSettings(false)} className="btn-back">
                ← Retour
              </button>
              <button onClick={handleSavePreferences} className="btn-save">
                Enregistrer mes choix
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default CookieConsent;

// Pour debug: forcer l'affichage
window.showCookieBanner = () => {
  localStorage.removeItem('cookieConsent');
  window.location.reload();
};